import useAppStore from "../stores/appStore";

import { getValidAccessToken } from "./tokenRefresh";
import { getTraceId } from "./traceId";

export const setAxiosTokenInterceptor = (axiosInstances) => {
  clearAllInterceptors(axiosInstances);
  axiosInstances.forEach((axiosInstance) => {
    axiosInstance.interceptors.request.use(async (requestConfig) => {
      const accessToken = await getValidAccessToken();
      const { selectedAssistant, selectedAccountId, previewToken } = useAppStore.getState();
      requestConfig.headers = {
        ...requestConfig.headers,
        "account-id": selectedAccountId,
        "room-id": selectedAssistant?.assistantId,
        "trace-id": getTraceId(),
        "Authorization": `Bearer ${accessToken}`,
        // The preview-link capability: lets the server authorize the preview surface
        // for visitors who are not members of the link's account.
        ...(previewToken ? { "preview-token": previewToken } : {})
      };
      return requestConfig;
    });
  });
};

export const clearAllInterceptors = (axiosInstances) => {
  axiosInstances.forEach((instance) => {
    const requestInterceptors = instance.interceptors.request;
    if (requestInterceptors.handlers) {
      requestInterceptors.handlers.forEach((handler, id) => {
        if (handler !== null) {
          requestInterceptors.eject(id);
        }
      });
    }
  });
};
